import { Box, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// assets
import logo from "../../assets/png/JioCloud-Logo.png";
//css
import classes from "../UserRegistration/UserRegistration.module.css";
import useApiHttp from "../../hooks/use-http";
import PageLoader from "../../components/UI/Loader/PageLoader";
import { Container } from "@jds/core";
import EmptyState from "../../components/NoData/EmptyState";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/state-slices/auth";

const UserRegistrationLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const params = new URLSearchParams(useLocation().search);
  const jwt = params.get("jwt");
  const eventId = params.get("eventId");
  const dcCode = params.get("dcCode");
  const vendorEventId = params.get("eventJWT")
  localStorage.eventJWT = vendorEventId
  localStorage.userRole = 'GUEST'

  const [isEventNotFound, setIsEventNotFound] = useState(false)
  const [loginError, setLoginError] = useState(false)
  const { sendRequest: loginCheckQrApi, isLoading: isLoadingLoginCheckQrApi } =
    useApiHttp();

  const loginCheckQrApiHandle = () => {
    loginCheckQrApi(
      {
        base: "AUTHV2",
        url: `user/login-and-check-qr`,
        method: "POST",
        body: {
          jcJwt: jwt,
          eventId,
          deviceType: "WEB",
          vendorEventId
        },
      },
      null,
      (data) => {
        localStorage.authToken = data.data.accessToken;
        localStorage.refreshToken = data.data.refreshToken;
        localStorage.dcCode = dcCode === 'jmng' ? 'jmng1' : dcCode;
        localStorage.eventName = data?.data?.eventName;
        // localStorage.bannerThumbnailURl = data?.data?.bannerThumbnail;
        localStorage.isRegisteredAlready = !data.data.isRegistrationRequired;
        localStorage.eventId = data?.data?.eventId;
        localStorage.eventName = data.data.eventName;

        dispatch(authActions.setLoginDetails(data?.data))

        if (data.data.isRegistrationRequired) {
          navigate(`/user-registered/event-registration?eventId=${data?.data?.eventId}`, { replace: true });
        } else if (!data?.data?.profilePictureThumbnail) {
          navigate(`/user-registered/user-status?eventId=${data?.data?.eventId}`, { replace: true });
        } else {
          navigate(`/user-registered/photos?eventId=${data?.data?.eventId}`, { replace: true });
        }
      },
      (err, data) => {
        if (data?.statusCode === 404) {
          setIsEventNotFound(true)
        } else if (data?.statusCode === 401) {
          localStorage.clear();
          window.location.href = vendorEventId ? `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/webview?id=JITOGUEST&eventJWT=${vendorEventId}` : `${process.env.REACT_APP_JIOCLOUD_LANDING_URL}/events/sign-up?event_id=${eventId}`
        } else {
          setLoginError(true)
        }
      }
    );
  };

  useEffect(() => {
    dispatch(authActions.setLoginDetails({
      eventJWT: vendorEventId,
      userRole: 'GUEST'
    }))
  }, [])

  useEffect(() => {
    loginCheckQrApiHandle();
  }, []);

  return (
    <>
      <header style={{ height: "50px", padding: "0 24px", backgroundColor: 'var(--color-primary-50)' }}>
        <div className={classes["header__container"]}>
          <Stack direction="row" gap={1} alignItems="center">
            <img src={logo} alt="jio photos logo" style={{ width: "40px" }} />
          </Stack>
        </div>
      </header>
      <Box>
        {isLoadingLoginCheckQrApi && (
          <PageLoader open={isLoadingLoginCheckQrApi} />
        )}
        {(isEventNotFound || loginError) && <Container paddingTop={180} fullWidth>
          <EmptyState
            title={loginError ? 'Something went wrong' : 'Event Not Found'}
            subtitle={"Please Try Again"}
            action={false}
          />
        </Container>}
      </Box>
    </>
  );
};

export default UserRegistrationLogin;
